export default "__VITE_ASSET__DWVZoP$T__"